module.exports = __webpack_public_path__ + "img/Frame_33.6d388680.png";